import { gql } from "@apollo/client";

export const LIST_COMPANIES_SOCIETE = gql`
  query listCompanies($limit: Int, $offset: Int, $search: String, $orderBy: [String!]) {
    listCompanies(filter: { name_Contains: $search }) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        vatNumber
        name
        headquartersNic
        establishments {
          address
          townshipCode
          township
          isHeadquarter
          postalCode
          address2
          addressNr
        }
      }
    }
  }
`;
export const LIST_COMPANIES_SOCIETE_SIRET = gql`
  query listCompanies($limit: Int, $offset: Int, $search: ID, $orderBy: [String!]) {
    listCompanies(filter: { vatNumber_Startswith: $search }) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        vatNumber
        name
        headquartersNic
        establishments {
          address
          townshipCode
          township
          isHeadquarter
          postalCode
          address2
          addressNr
        }
      }
    }
  }
`;

export const LIST_COMPANIES_CUSTOM = gql`
  query listCompanies(
    $limit: Int
    $offset: Int
    $nameContains: String
    $orderBy: [String!]
    $vatNumberStartswith: ID
  ) {
    listCompanies(
      filter: { name_Contains: $nameContains, vatNumber_Startswith: $vatNumberStartswith }
    ) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        vatNumber
        name
        headquartersNic
        establishments {
          address
          townshipCode
          township
          isHeadquarter
          postalCode
          address2
          addressNr
        }
      }
    }
  }
`;

export const GET_CLIENTS_XLSX = gql`
  query getClientsXlsx($filter: ClientXlsxFilter) {
    getClientsXlsx(filter: $filter)
  }
`;
